import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Alert from '@material-ui/lab/Alert';

// Plan 036 (frontière vivier), P4: a Cleaner fiche whose employee_status is
// "Vivier salarial" belongs to the vivier world, worked from Profil vivier
// (/person_vivier), not from here. This banner only points there — no
// automatic redirect, the Cleaner fiche stays reachable for its remaining
// legitimate uses (courriers, préaffectation — see plan §2 P4).
const VivierBanner = ({ record }) => {
  if (!record || record.employee_status !== 'Vivier salarial') {
    return null;
  }
  return (
    <Alert severity="info" style={{ marginBottom: 8 }}>
      Cette personne est au vivier —{' '}
      <Link to={`/person_vivier/${encodeURIComponent(record.id)}/show`}>
        ouvrir son Profil vivier
      </Link>
    </Alert>
  );
};

VivierBanner.propTypes = {
  record: PropTypes.object,
};

VivierBanner.defaultProps = {
  record: undefined,
};

export default VivierBanner;
